module.exports = __webpack_public_path__ + "img/pg.467b1242.svg";